<div class="content">
  <div class="body">
    <div class="section primary">
      <div class="container">
        <button mat-button class="text-button back-button" (click)="goBack()" [disabled]="waiting">
          <img class="icon" src="assets/content-icon/ic-07.svg" />
          <span class="text">Back</span>
        </button>
        <div class="page" *ngIf="page == 'forgot'">
          <span class="title">{{getForgotPageTitleText()}}</span>
          <span class="desc">Enter your email address below, and we will send you {{getForgotPageDescriptionContext()}} instructions.</span>
          <div class="text-field">
            <span class="title">Email</span>
            <input type="text" class="input" name="username" id="username" [(ngModel)]="email" placeholder="Your Email" maxlength="255" [disabled]="waiting" />
          </div>
        </div>
        <div class="page" *ngIf="page == 'reset'">
          <span class="title">Reset Password</span>
          <span class="desc">We’ve sent a code to {{email}}. Check your inbox and junk mail folders to let us know your code below.</span>
          <div class="text-field">
            <span class="title">Code</span>
            <input numberInput type="text" class="input" [(ngModel)]="code" placeholder="Your Code" maxlength="4" [disabled]="waiting" />
          </div>
          <div class="text-field">
            <span class="title">New password</span>
            <div class="input-container">
              <input [type]="passwordShowing ? 'text' : 'password'" name="password" id="password" class="input" [(ngModel)]="password1"
                placeholder="Your new password" [disabled]="waiting" />
              <div class="inline-text-button" (click)="togglePasswordShowing()">{{passwordShowing ? 'Hide' : 'Show'}}</div>
            </div>
          </div>
          <div class="text-field">
            <span class="title">Confirm new password</span>
            <div class="input-container">
              <input [type]="passwordShowing ? 'text' : 'password'" class="input" [(ngModel)]="password2"
                placeholder="Your new password" [disabled]="waiting" />
              <div class="inline-text-button" (click)="togglePasswordShowing()">{{passwordShowing ? 'Hide' : 'Show'}}</div>
            </div>
          </div>
          <div class="password-checks">
            <div class="condition">
              <img src="assets/check.svg" class="check" [ngClass]="{active: passwordCharacterCountGood()}" />
              <span class="text">Must be at least 8 characters</span>
            </div>
            <div class="condition">
              <img src="assets/check.svg" class="check" [ngClass]="{active: passwordCapitalizationGood()}" />
              <span class="text">Have uppercase and lowercase letters</span>
            </div>
            <div class="condition">
              <img src="assets/check.svg" class="check" [ngClass]="{active: passwordNumberGood()}" />
              <span class="text">Have a number</span>
            </div>
            <div class="condition">
              <img src="assets/check.svg" class="check" [ngClass]="{active: passwordSpecialCharacterGood()}" />
              <span class="text">Have a special character or symbol</span>
            </div>
            <div class="condition">
              <img src="assets/check.svg" class="check" [ngClass]="{active: passwordsMatch()}" />
              <span class="text">Passwords must match</span>
            </div>
          </div>
        </div>
        <div class="page" *ngIf="page == 'activate'">
          <span class="title">Activate Account</span>
          <span class="desc">We’ve sent a code to {{email}} Check your inbox and junk mail folders to let us know your code below.</span>
          <div class="text-field">
            <span class="title">Code</span>
            <input numberInput type="text" class="input" [(ngModel)]="code" placeholder="Your Code" maxlength="4" [disabled]="waiting" />
          </div>
          <div class="text-field">
            <span class="title">Password</span>
            <div class="input-container">
              <input [type]="passwordShowing ? 'text' : 'password'"  name="password" id="password" class="input" [(ngModel)]="password1"
                placeholder="Your Password" [disabled]="waiting" />
              <div class="inline-text-button" (click)="togglePasswordShowing()">{{passwordShowing ? 'Hide' : 'Show'}}</div>
            </div>
          </div>
        </div>
        <div class="buttons">
          <button mat-button class="button primary full-width" (click)="goNext()" [disabled]="!canGoNext()">
            <span *ngIf="waiting != 'main'">{{getButtonText()}}</span>
            <mat-progress-spinner *ngIf="waiting == 'main'" class="spinner" mode="indeterminate" diameter="25"></mat-progress-spinner>
          </button>
        </div>
        <div class="options" *ngIf="page != 'forgot'">
          <button mat-button class="option text-button underline centered custom-size custom-color" (click)="sendNewCode()" [disabled]="waiting">
            <mat-progress-spinner *ngIf="waiting == 'code'" class="spinner primary" mode="indeterminate" diameter="17"></mat-progress-spinner>
            Send a new code
          </button>
        </div>
      </div>
    </div>
    <div class="section secondary"></div>
  </div>
</div>
